var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlusDs = function SvgPlusDs(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.328 11.932C22.3279 11.2151 21.753 10.6402 21.0362 10.6402L13.2261 10.6395L13.2254 2.82941C13.2254 2.11256 12.6505 1.53768 11.9336 1.53764C11.2168 1.5376 10.642 2.11241 10.642 2.82927L10.6427 10.6394L2.83091 10.6404C2.11405 10.6403 1.53925 11.2151 1.53929 11.932C1.53931 12.2836 1.68135 12.615 1.9113 12.845C2.14124 13.0749 2.46587 13.2237 2.8243 13.217L10.6361 13.216L10.6486 21.0413C10.6486 21.393 10.7907 21.7244 11.0206 21.9543C11.2573 22.191 11.5752 22.3331 11.9336 22.3263C12.6505 22.3264 13.2253 21.7516 13.2252 21.0347L13.2262 13.2229L21.0363 13.2236C21.7532 13.2236 22.328 12.6488 22.328 11.932Z",
    fill: "#9496A9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlusDs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Plus-ds.0d818203a161d343df76ad092f095245.svg";